import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';

const DebugPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  
  const fetchDirectSheetsData = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      // Direct API call without any service wrappers
      const apiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${config.google_sheet_id}/values/${config.SHEET_RANGE}?key=${config.GOOGLE_API_KEY}`;
      console.log('Attempting to fetch from:', apiUrl);
      
      const result = await axios.get(apiUrl);
      console.log('API Response:', result);
      
      setResponse(result.data);
    } catch (err) {
      console.error('Debug fetch error:', err);
      setError(err.toString());
      
      // Also try to get the detailed error response
      if (err.response) {
        setError(`${err.toString()}\n\nResponse: ${JSON.stringify(err.response.data, null, 2)}`);
      }
    } finally {
      setLoading(false);
    }
  };
  
  const fetchWithCorsProxy = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      // Try with CORS proxy
      const corsProxyUrl = config.CORS_PROXY_URL;
      const apiUrl = `${corsProxyUrl}https://sheets.googleapis.com/v4/spreadsheets/${config.google_sheet_id}/values/${config.SHEET_RANGE}?key=${config.GOOGLE_API_KEY}`;
      
      console.log('Attempting to fetch with CORS proxy:', apiUrl);
      
      const result = await axios.get(apiUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      
      console.log('CORS Proxy API Response:', result);
      
      setResponse(result.data);
    } catch (err) {
      console.error('Debug CORS proxy fetch error:', err);
      setError(err.toString());
      
      // Also try to get the detailed error response
      if (err.response) {
        setError(`${err.toString()}\n\nResponse: ${JSON.stringify(err.response.data, null, 2)}`);
      }
    } finally {
      setLoading(false);
    }
  };
  
  const testDriveFolder = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      // Extract the folder ID
      const folderUrl = config.DEFAULT_DRIVE_FOLDER;
      const match = folderUrl.match(/[-\w]{25,}/);
      const folderId = match ? match[0] : null;
      
      if (!folderId) {
        throw new Error('Could not extract folder ID from URL');
      }
      
      // Try to list files in the folder
      const apiUrl = `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${config.GOOGLE_API_KEY}`;
      
      console.log('Attempting to fetch Drive folder contents:', apiUrl);
      
      const result = await axios.get(apiUrl);
      console.log('Drive API Response:', result);
      
      setResponse(result.data);
    } catch (err) {
      console.error('Debug Drive fetch error:', err);
      setError(err.toString());
      
      // Also try to get the detailed error response
      if (err.response) {
        setError(`${err.toString()}\n\nResponse: ${JSON.stringify(err.response.data, null, 2)}`);
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="debug-page" style={{ padding: '20px', maxWidth: '90%', margin: '0 auto' }}>
      <h1>API Debugging Page</h1>
      
      <div className="config-info" style={{ marginBottom: '20px' }}>
        <h2>Current Configuration:</h2>
        <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '5px', overflow: 'auto' }}>
          {JSON.stringify({
            API_KEY: config.GOOGLE_API_KEY ? `${config.GOOGLE_API_KEY.substring(0, 5)}...` : 'Not set',
            SHEET_RANGE: config.SHEET_RANGE,
            google_sheet_id: config.google_sheet_id,
            DEFAULT_DRIVE_FOLDER: config.DEFAULT_DRIVE_FOLDER,
            USE_CORS_PROXY: config.USE_CORS_PROXY,
            CORS_PROXY_URL: config.CORS_PROXY_URL
          }, null, 2)}
        </pre>
      </div>
      
      <div className="actions" style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button 
          onClick={fetchDirectSheetsData}
          disabled={loading}
          style={{ padding: '10px 15px', background: '#1976D2', color: 'white', border: 'none', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          Test Direct Sheets API
        </button>
        
        <button 
          onClick={fetchWithCorsProxy}
          disabled={loading}
          style={{ padding: '10px 15px', background: '#388E3C', color: 'white', border: 'none', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          Test With CORS Proxy
        </button>
        
        <button 
          onClick={testDriveFolder}
          disabled={loading}
          style={{ padding: '10px 15px', background: '#FFA000', color: 'white', border: 'none', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          Test Drive Folder Access
        </button>
      </div>
      
      {loading && (
        <div className="loading" style={{ margin: '20px 0' }}>
          <p>Loading...</p>
        </div>
      )}
      
      {error && (
        <div className="error" style={{ margin: '20px 0' }}>
          <h3>Error:</h3>
          <pre style={{ background: '#ffebee', padding: '10px', borderRadius: '5px', color: '#d32f2f', whiteSpace: 'pre-wrap', overflow: 'auto' }}>
            {error}
          </pre>
        </div>
      )}
      
      {response && (
        <div className="response" style={{ margin: '20px 0' }}>
          <h3>Response:</h3>
          <pre style={{ background: '#e8f5e9', padding: '10px', borderRadius: '5px', color: '#2e7d32', whiteSpace: 'pre-wrap', overflow: 'auto' }}>
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default DebugPage;
